import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import Root from '../components/common/root/root'
import Home from '../components/home/home/home'
import ShoppingCart from '../components/shoppingCart/shoppingCart/shoppingCart'
import Mine from '../components/mine/mine/mine'
import ProductDetail from '../components/home/productDetail/productDetail'
import ChooseCity from '../components/common/chooseCity/chooseCity'
import ProductList from '@/components/home/home/productList'
import UserAccountInfo from '@/components/mine/userAccountInfo/userAccountInfo'
import UserAccountSet from '@/components/mine/userAccountSet/userAccountSet'
import AboutBlissMall from '@/components/mine/aboutBlissMall/aboutBlissMall'
import MyBill from '@/components/mine/myBill/myBill'
import Login from '@/components/common/login/login'
import LoginEntrance from '@/components/common/login/loginEntrance'
import PhoneNumlogin from '@/components/common/login/phoneNumLogin'
import ResetPassword from '@/components/mine/userAccountSet/resetPassword'
import bindMobilePhone from '@/components/mine/userAccountSet/bindMobilePhone'
import setPassword from '@/components/mine/userAccountSet/setPassword'
//setPassword deliveryArea
import deliveryArea from '@/components/common/deliveryArea/deliveryArea'
import ForgetPassword from '@/components/common/login/forgetPassword'
import pageNotFound from '@/components/common/global/pageNotFound'
import BirthBrand from'@/components/shoppingCart/shoppingCart/birthBrand'
import FirmOrder from '@/components/shoppingCart/firmOrder'

import OrderDetails from '@/components/order/orderDetails'
import PayTypes from '@/components/order/payTypes'
import PaySuccess from '@/components/order/paySuccess'
import PayZfb from '@/components/order/payZFB'
import PayZfbTips from '@/components/order/payZFBTips'
import PaySucSure from '@/components/order/paySucSure'
import AddressList from '@/components/address/addressList'
import AddressEdit from '@/components/address/addressEdit'
import AddressNoLoginAdd from '@/components/address/addressNologinAdd'

import Register from '@/components/common/register/register'
import userAgreement from '@/components/common/register/userAgreement'
//register
import OrderCancel from '@/components/order/orderCancel'
import OrderRefundDetails from '@/components/order/orderRefundDetails'
import OrderManager from '@/components/order/orderManager'
import ExpressList from '@/components/order/expressList'


// import Test from '@/components/test'

// import login from '../login'
Vue.use(Router)
Vue.use(Vuex)

export default new Router({
  // hashbang: true,
  // history: true,
  // mode: 'history',
  routes: [
    { path: '*', component: pageNotFound },
    {
      path: '/',
      name: 'Root',
      component: Root,
      children: [
        {
          path: '/',
          component: Home
        },
        {
          path: '/ShoppingCart',
          component: ShoppingCart
        },
        {
          path: '/Mine',
          component: Mine
        },
        {
          path: '/Home',
          component: Home
        }
      ]
    },
    {
      name: 'productShoppingCart',
      path: '/productShoppingCart',
      component: ShoppingCart
    },
    {
      path: '/productList',
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/productList/:id',
      name: 'ProductListId',
      component: ProductList
    },
    {
      path: '/productList/parentId/:parentId',
      name: 'ProductListParentId',
      component: ProductList
    },
    {
      path: '/productdetail/:id',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/chooseCity',
      name: 'chooseCity',
      component: ChooseCity
    }, // userAccountInfo
    {
      path: '/userAccountSet/info',
      name: 'userAccountInfo',
      component: UserAccountInfo
    }, // userAccountInfo
    {
      path: '/userAccountSet',
      name: 'userAccountSet',
      component: UserAccountSet
    },// bindMobilePhone
    {
      path: '/userAccountSet/bindMobilePhone',
      name: 'bindMobilePhone',
      component: bindMobilePhone
    },
    {
      path: '/userAccountSet/setPassword',
      name: 'setPassword',
      component: setPassword
    },
    {
      path: '/aboutBlissMall',
      name: 'aboutBlissMall',
      component: AboutBlissMall
    },
    {
      path: '/mine/myBill',
      name: 'myBill',
      component: MyBill
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }, // PhoneNumlogin
    {
      path: '/phoneNumlogin',
      name: 'phoneNumlogin',
      component: PhoneNumlogin
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: ResetPassword
    }, //
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: ForgetPassword
    },
    {
      path: '/birthBrand',
      name: 'birthBrand',
      component: BirthBrand
    },
    {
      path: '/firmOrder',
      name: 'firmOrder',
      component: FirmOrder
    },
    {
      path: '/orderManager/:status',
      name: 'orderManager',
      component: OrderManager
    },
    {
      path: '/orderDetails/:mchId',
      name: 'orderDetails',
      component: OrderDetails
    },
    {
      path: '/orderCancel/:orderId',
      name: 'orderCancel',
      component: OrderCancel
    },
    {
      path: '/expressList/:orderId',
      name: 'expressList',
      component: ExpressList
    },
    {
      path: '/orderRefundDetails/:orderCode',
      name: 'orderRefundDetails',
      component: OrderRefundDetails
    },
    {
      path: '/addressList',
      name: 'addressList',
      component: AddressList
    },
    {
      path: '/addressList/choose',
      name: 'addressChoose',
      component: AddressList
    },
    {
      path: '/addressEdit/edit/:id',
      name: 'addressEdit',
      component: AddressEdit
    },
    {
      path: '/addressEdit/add',
      name: 'addressAdd',
      component: AddressEdit
    },{
      path: '/addressNoLoginAdd',
      name: 'addressNoLoginAdd',
      component: AddressNoLoginAdd
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/loginEntrance',
      name: 'loginEntrance',
      component: LoginEntrance
    },
    {
      path: '/deliveryArea',
      name: 'deliveryArea',
      component: deliveryArea
    },
    {
      path: '/payZfb/:payNo',
      name: 'payZfb',
      component: PayZfb
    },
    {
      path: '/paySucSure/:payNo',
      name: 'paySucSure',
      component: PaySucSure
    },
     {
      path: '/payTypes/:payNo',
      name: 'payTypes',
      component: PayTypes 
    },
    {
      path: '/paySuccess/:mchId',
      name: 'paySuccess',
      component: PaySuccess
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement

    },{
      path: '/payZfbTips',
      name: 'payZfbTips',
      component: PayZfbTips
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js